import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <section className="empty-page">
      <span className="eyebrow">404</span>
      <h1>页面不存在</h1>
      <p>该页面尚未发布，或你访问的地址不正确。</p>
      <Link to="/">返回工作台</Link>
    </section>
  );
}
